
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import * as moment from 'moment';

import { TeemappTableComponent } from '@teem/shared-component/teemapp-table/teemapp-table.component';
import { SharedDataService } from '@teem/services/shared-data.service';
import { ACTIONS as INVOICE_ACTIONS } from '@teem/constants/invoice';
import { UserCurrencyPipe } from '@teem/pipes/user-currency.pipe';
import { ngDebounce } from '@teem/decorators/debouce.decorator';
import { InvoiceService } from '@teem/services/invoice.service';
import { LoaderService } from '@teem/services/loader.service';
import { messages as i18n } from '@teem/constants/messages';
import { UserService } from '@teem/services/user.service';
import { Invoice } from '@teem/models/invoice';

import { RecordPaymentModalComponent } from '@teem/payments-module/modals/record-payment-modal/record-payment-modal.component';
import { InvoiceRefModalComponent } from '@teem/invoices-module/modals/invoice-ref-modal/invoice-ref-modal.component';

import ReceivedPaymentTableSchema from '@teem/payments-module/classes/received-payment-table-schema';
import PendingPaymentTableSchema from '@teem/payments-module/classes/pending-payment-table-schema';
import { FailedPaymentTableSchema } from '@teem/payments-module/classes/failed-payment-table-schema';
declare var $;

@Component({
  selector: 'app-payments',
  templateUrl: './payments.component.html',
  styles: ['./payments.component.css'],
  providers: [UserCurrencyPipe]
})
export class PaymentsComponent implements OnInit {
  @ViewChild('receivedPaymentsTableRef') receivedPaymentsTableRef: TeemappTableComponent;
  @ViewChild('pendingPaymentsTableRef') pendingPaymentsTableRef: TeemappTableComponent;
  @ViewChild('failedPaymentTableRef') failedPaymentTableRef: TeemappTableComponent;
 

  activeTab: string = 'received-payments';
  isPaymentTab: string = 'payments-tab';
  
  invoicesCount: number = 0;
  receivedPaymentsCount: number = 0;
  failedPaymentsCount: number = 0;
  draftsCount: number = 0;
  activeInvoice: any;
  allInvoicesSum: number = 0;
  closedInvoicesSum: number = 0;
  pendingInvoicesSum: number = 0;
  routeSubscriber: any;
  selectedClientUid: string;
  isInvoiceSelected: boolean = false;
  isDraftSelected: boolean = false;
  userInfo: any;
  permissions: any;
  invoiceRowData: any;
  // Invoice table variables
  pendingPaymentsTable: PendingPaymentTableSchema = new PendingPaymentTableSchema(this);
  invoiceMenuItems: Array<any> = [
    { key: "pay_invoice", label: $localize`:@@ts.pay_invoices:Pay invoices`, onClick: this.payInvoices.bind(this) },
    { key: "add_online_payment", label: $localize`:@@ts.add_online_payment:Add Online Payment`, onClick: '', singleOnly: true, visible: false }
  ];

  // Received payments table scheme
  receivedPaymentsTable: ReceivedPaymentTableSchema = new ReceivedPaymentTableSchema(this);

  failedPaymentTable: FailedPaymentTableSchema = new FailedPaymentTableSchema(this);

  constructor(
    private invoiceService: InvoiceService,
    private modalService: NgbModal,
    private loaderService: LoaderService,
    private route: ActivatedRoute,
    private currencyPipe: UserCurrencyPipe,
    private router: Router,
    private userService: UserService,
    private sharedDataService: SharedDataService) { }

  ngOnInit(): void {
    this.loadCommonData();

    this.routeSubscriber = this.route.queryParams.subscribe(params => {
      // Defaults to 0 if no query param provided.
      if (params && params['pending-payment']) {
        this.activeTab = "pending-payments";
      }
    });


    // Show/Hide whatsapp action as per pro plan
    this.sharedDataService.asObservable().subscribe((data) => {
      if (data) {
        if (data.userInfo) {
          this.userInfo = data.userInfo
        }

        if (data.permissions) {
          this.permissions = data.permissions;
        }
      }
    })
  }

  loadCommonData() {
    this.invoiceService.stats().subscribe((data: any) => {
      this.allInvoicesSum = data.all;
      this.closedInvoicesSum = data.closed;
      this.pendingInvoicesSum = data.pending;
    })
  }

  fetchPermissions() {
    this.userService.getPermissions().subscribe((data: any) => {
      if (data) {
        this.sharedDataService.setItem('permissions', data);
      }
    });
  }

  filterByDate(params) {

    if (!(params.from_date || params.to_date)) {
      // On clear button click - Because we can't reset date filter individually for each table so here reload all tables when clear btn clicked.  
      this.pendingPaymentsTableRef.resetDateFilters();
      this.receivedPaymentsTableRef.resetDateFilters();
      this.failedPaymentTableRef.resetDateFilters();

      this.pendingPaymentsTableRef.getPage(1);
      this.receivedPaymentsTableRef.getPage(1);
      this.failedPaymentTableRef.getPage(1);
    } else if (params.from_date && params.to_date) {

      if (this.activeTab == 'pending-payments') {
        this.pendingPaymentsTableRef.getPage(1, false, params);
      } else if (this.activeTab == 'received-payments') {
        this.receivedPaymentsTableRef.getPage(1, false, params);
      } else if (this.activeTab == 'failed-payments') {
        this.failedPaymentTableRef.getPage(1, false, params);
      } 
      else if (this.activeTab == 'drafts') {
      }
    }
  }

  // function called after 2s
  @ngDebounce(500)
  filterByAmount(params) {
    // if (params.min_amount || params.max_amount) {

    if (this.activeTab == 'pending-payments') {
      this.pendingPaymentsTableRef.getPage(1, false, params);
    } else if (this.activeTab == 'received-payments') {
      this.receivedPaymentsTableRef.getPage(1, false, params);
    }
    else if (this.activeTab == 'failed-payments') {
      this.failedPaymentTableRef.getPage(1, false, params);
    } 
    // }
  }

  filterByStatus(params) {
    // if (params.invoice_status) {
    if (this.activeTab == 'pending-payments') {
      this.pendingPaymentsTableRef.getPage(1, false, params);
    } else if (this.activeTab == 'received-payments') {
      this.receivedPaymentsTableRef.getPage(1, false, params);
    }
    else if (this.activeTab == 'failed-payments') {
      this.failedPaymentTableRef.getPage(1, false, params);
    } 
    // }
  }

  // ngOnDestroy() {
  //   this.routeSubscriber.unsubscribe();
  // }

  switchTab(tab) {
    this.invoiceRowData =null;
    this.activeTab = tab;

     this.pendingPaymentsTableRef.reset();
     this.receivedPaymentsTableRef.reset();
     this.failedPaymentTableRef.reset();
  }

  invoiceActions(action, invoice: any) {
    this.invoiceRowData = invoice;
    switch (action) {
      case INVOICE_ACTIONS.VIEW:
        this.viewInvoice([invoice.invoice_uuid])
        break;
      case INVOICE_ACTIONS.RESEND_PAYMENT:
        this.resendPayments(invoice.uuid)
        break;
      case INVOICE_ACTIONS.ACCEPT_PAYMENT:
        this.acceptPayments(invoice.uuid)
        break;
      case INVOICE_ACTIONS.REJECT_PAYMENT:
        this.rejectPayments(invoice.uuid)
        break;
      case INVOICE_ACTIONS.COPY_CLIPBOARD:
        this.generateInvoiceLink(invoice.payment_refer_number);
        break;
      case INVOICE_ACTIONS.DELETE_PAYMENT:
        this.deleteInvoices([invoice.uuid])
        break;
      case INVOICE_ACTIONS.REFUND_ONLINE_PAYMENT:
        this.refundPayment(invoice.invoice_uuid)
        break;
    }
  }

  refundPayment(selectedInvoices: string) {
    if (this.invoiceRowData) {
      Swal.fire({
        title: i18n.are_you_sure,
        text: i18n.invoice.you_want_to_update_invoice,
        icon: 'info',
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: i18n.yes,
        cancelButtonText: i18n.no_cancel_it
      }).then(result => {
        if (result.value) {
          this.loaderService.startLoading();
          this.invoiceService.refundOnlinePayment(selectedInvoices).subscribe(data => {
            this.loaderService.stopLoading();
            this.activeTab = 'received-payments';
            this.receivedPaymentsTableRef.getPage(1);
            Swal.fire(i18n.done, i18n.payment.update_successfully, 'success');
          }, err => {
            this.loaderService.stopLoading();
            Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
          });
        }
      });
    }
  }

  deleteInvoices(selectedInvoices) {
    if (selectedInvoices.length) {
      Swal.fire({
        title: i18n.are_you_sure,
        text: i18n.invoice.you_want_to_delete_invoice,
        icon: 'info',
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText:
          i18n.yes,
        cancelButtonText:
          i18n.no_cancel_it
      }).then(result => {
        if (result.value) {

          this.loaderService.startLoading();

          this.invoiceService.deletePayment(selectedInvoices).subscribe(data => {
            this.loaderService.stopLoading();

            this.activeTab = 'pending-payments';
            this.receivedPaymentsTableRef.getPage(1);
            this.pendingPaymentsTableRef.getPage(1);
            this.failedPaymentTableRef.getPage(1);

            Swal.fire(i18n.done, i18n.payment.deleted_successfully, 'success');

            this.loadCommonData();
            this.fetchPermissions();

          }, err => {
            this.loaderService.stopLoading();
            Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
          });
        }
      });
    }
  }

  generateInvoiceLink(invoiceRefNum) {
    const modalRef = this.modalService.open(InvoiceRefModalComponent);

    // Set id on modal dialog
    modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentElement.id = "quick-payment";
    modalRef.componentInstance.invoiceRefNum = invoiceRefNum;
    modalRef.componentInstance.onSuccess = () => {

    };

    modalRef.result.then(result => {

    }, fallbackResult => {

    })
  }

  toggleTableMenu() {
    if (this.activeTab == 'pending-payments') {
      if (this.isInvoiceSelected) {
        this.pendingPaymentsTableRef.toggleMenu();
      } else {
        Swal.fire(i18n.invoice.please_select_invoice);
      }
    }
  }

  onLoadPendingInvoices(data: any) {
    this.invoicesCount = data.totalItems ? data.totalItems : 0;

    setTimeout(() => {
      $('#tab-links-select[nice-select]').niceSelect('update');
    }, 10);
  }

  onLoadFailedInvoices(data: any) {
    this.failedPaymentsCount = data.totalItems ? data.totalItems : 0;

    setTimeout(() => {
      $('#tab-links-select[nice-select]').niceSelect('update');
    }, 10);
  }

  onLoadReceivedPayments(data: any) {
    this.receivedPaymentsCount = data.totalItems ? data.totalItems : 0;

    setTimeout(() => {
      $('#tab-links-select[nice-select]').niceSelect('update');
    }, 10);
  }


  searchInvoices(term: string) {
    if (this.activeTab == 'pending-payments') {
      this.pendingPaymentsTableRef.search.next(term);
    } else if (this.activeTab == 'received-payments') {
      this.receivedPaymentsTableRef.search.next(term);
    }
    else if (this.activeTab == 'failed-payments') {
      this.failedPaymentTableRef.search.next(term);
    }
    
  }


  payInvoices(selectedInvoices: Array<string>) {
    if (selectedInvoices.length) {
      this.loaderService.startLoading();
      this.invoiceService.action({ 'do': INVOICE_ACTIONS.PAY, 'ids': selectedInvoices }).subscribe(data => {
        this.loaderService.stopLoading();
        this.activeTab = "pending-payments";
        Swal.fire(i18n.done, i18n.invoice.invoice_paid, 'success');

        this.pendingPaymentsTableRef.getPage(1);
        this.receivedPaymentsTableRef.getPage(1);
        this.failedPaymentTableRef.getPage(1);
        this.loadCommonData();

      }, err => {
        this.loaderService.stopLoading();

        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      });
    }
  }

  payIncash(obj: any) {

    let todaysDate = new Date();
    let fb = {
      invoice_id: obj.details.id,
      client_id: obj.details.client_id,
      invoice_number: obj.details.invoice_number,
      date: todaysDate,
      amount: obj.details.due_amount,
      payment_type: obj.payment_method
    };

    this.loaderService.startLoading();
    this.invoiceService.createPayment(fb).subscribe(data => {
      this.loaderService.stopLoading();
      this.activeTab = "pending-payments";
      Swal.fire(i18n.done, i18n.invoice.invoice_paid, 'success');
      this.pendingPaymentsTableRef.getPage(1);
      this.receivedPaymentsTableRef.getPage(1);
      this.failedPaymentTableRef.getPage(1);
      this.loadCommonData();

    }, err => {
      this.loaderService.stopLoading();

      Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
    });

  }

  resendPayments(selectedInvoices: string) {
    if (selectedInvoices.length) {
      Swal.fire({
        title: i18n.are_you_sure,
        text: i18n.invoice.you_want_to_resend_invoice_payment,
        icon: 'info',
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText:
          i18n.yes,
        cancelButtonText:
          i18n.no_cancel_it
      }).then(result => {
        if (result.value) {

          this.loaderService.startLoading();

          this.invoiceService.resendPayment(selectedInvoices).subscribe(data => {
            this.loaderService.stopLoading();

            this.activeTab = 'received-payments';
            this.receivedPaymentsTableRef.getPage(1);
            this.pendingPaymentsTableRef.getPage(1);
            this.failedPaymentTableRef.getPage(1);

            Swal.fire(i18n.done, i18n.invoice.resend_payment, 'success');

            this.loadCommonData();
            this.fetchPermissions();

          }, err => {
            this.loaderService.stopLoading();
            Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
          });
        }
      });
    }
  }

  acceptPayments(selectedInvoices: string) {
    if (selectedInvoices.length) {
      Swal.fire({
        title: i18n.are_you_sure,
        text: i18n.payment.update_to_accept,
        icon: 'info',
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText:
          i18n.yes,
        cancelButtonText:
          i18n.no_cancel_it
      }).then(result => {
        if (result.value) {

          this.loaderService.startLoading();

          this.invoiceService.acceptPayment(selectedInvoices).subscribe(data => {
            this.loaderService.stopLoading();

            this.activeTab = 'pending-payments';
            this.receivedPaymentsTableRef.getPage(1);
            this.pendingPaymentsTableRef.getPage(1);
            this.failedPaymentTableRef.getPage(1);

            Swal.fire(i18n.done, i18n.payment.update_successfully, 'success');

            this.loadCommonData();
            this.fetchPermissions();

          }, err => {
            this.loaderService.stopLoading();
            Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
          });
        }
      });
    }
  }

  rejectPayments(selectedInvoices: string) {
    if (selectedInvoices.length) {
      Swal.fire({
        title: i18n.are_you_sure,
        text: i18n.payment.update_to_reject,
        icon: 'info',
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText:
          i18n.yes,
        cancelButtonText:
          i18n.no_cancel_it
      }).then(result => {
        if (result.value) {

          this.loaderService.startLoading();

          this.invoiceService.rejectPayment(selectedInvoices).subscribe(data => {
            this.loaderService.stopLoading();

            this.activeTab = 'pending-payments';
            this.receivedPaymentsTableRef.getPage(1);
            this.pendingPaymentsTableRef.getPage(1);
            this.failedPaymentTableRef.getPage(1);

            Swal.fire(i18n.done, i18n.payment.update_successfully, 'success');

            this.loadCommonData();
            this.fetchPermissions();

          }, err => {
            this.loaderService.stopLoading();
            Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
          });
        }
      });
    }
  }


  recordPayment() {
    const modalRef = this.modalService.open(RecordPaymentModalComponent);

    // Set id on modal dialog
    modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentElement.id = "recordpayment";
    modalRef.componentInstance.userInfo = this.userInfo;

    modalRef.result.then(result => {
      this.pendingPaymentsTableRef.getPage(1);
      this.receivedPaymentsTableRef.getPage(1);
      this.failedPaymentTableRef.getPage(1);
      this.loadCommonData();
    }, fallbackResult => {

    })
  }

  recordNewPayment(data: any) {
    const modalRef = this.modalService.open(RecordPaymentModalComponent);

    // Set id on modal dialog
    modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentElement.id = "recordpayment";
    modalRef.componentInstance.userInfo = this.userInfo;
    modalRef.componentInstance.invoice = this.invoiceRowData;

    modalRef.result.then(result => {
      this.receivedPaymentsTableRef.getPage(1);
      this.loadCommonData();
    }, fallbackResult => {

    })
  }

  editInvoice(invoice: Invoice) {
    this.activeInvoice = invoice;
    this.activeTab = "edit-invoice";
  }

  doAction(obj: any) {
    switch (obj.action) {
      case "email":
        this.emailInvoices([obj.invoice.uuid]);
        break;
      case "whatsapp":
        this.whatsappInvoices([obj.invoice.uuid]);
        break;
      case "pay":
        this.payInvoices([obj.invoice.uuid]);
        break;
    }
  }

  emailInvoices(selectedInvoices: Array<string>) {
    if (selectedInvoices.length) {
      this.loaderService.startLoading();

      this.invoiceService.action({ 'do': INVOICE_ACTIONS.EMAIL, 'ids': selectedInvoices }).subscribe(data => {
        this.loaderService.stopLoading();

        Swal.fire(i18n.done, i18n.email_sent, 'success');
        this.receivedPaymentsTableRef.getPage(1);

      }, err => {
        this.loaderService.stopLoading();
        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      });
    }
  }

  whatsappInvoices(selectedInvoices: Array<string>) {
    if (selectedInvoices.length) {
      this.loaderService.startLoading();

      this.invoiceService.action({ 'do': INVOICE_ACTIONS.WHATSAPP, 'ids': selectedInvoices }).subscribe(data => {
        this.loaderService.stopLoading();
        Swal.fire(i18n.done, i18n.invoice.whatsapp_message_sent, 'success');

      }, err => {
        this.loaderService.stopLoading();
        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      });
    }
  }

  onDeleteInvoice(invoice: Invoice) {
    this.deleteInvoices([invoice.uuid]);
    // this.activeInvoice = false;
  }
  
  viewInvoice(selectedInvoices: Array<string>) {
    if (selectedInvoices.length === 1) {
      this.loaderService.startLoading();
      this.invoiceService.get(selectedInvoices[0]).subscribe((invoice: Invoice) => {
        this.activeInvoice = invoice;
        this.activeTab = "view-invoice";
        this.loaderService.stopLoading();
      }, err => {
        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
        this.loaderService.stopLoading();
      })
    }
  }


}



